import {
  UPDATE_DESTINATIONS,
  TOGGLE_LOADING_DESTINATIONS,
  IDestinationsStoreState,
  DestinationsActionTypes,
} from './types';

const initialState: IDestinationsStoreState = {
  isLoading: false,
  data: null,
};

export default function homePageReducer(state = initialState, action: DestinationsActionTypes) {
  switch (action.type) {
    case UPDATE_DESTINATIONS:
      return {
        ...state,
        data: action.actionData,
      };

    case TOGGLE_LOADING_DESTINATIONS:
      return {
        ...state,
        isLoading: action.actionData,
      };

    default:
      return state;
  }
}
